import React from 'react';
import {connect} from "react-redux";
import {showAddWordsModal, textAreaWordsChange} from "../add-words/add-words-action-creators";
import {getSelectedText} from "./context-menu-functions";
import "./context-menu.css";
import {hideContextMenu} from "./context-menu-action-creators";


const ContextMenu = (
  {
    top,
    left,
    isShown,
    addToTaxonomy,
    selectedText
  }
) => {
  return (
    <div
      className="shadow"
      style={{
        display: isShown ? 'flex' : 'none',
        flexDirection: 'column',
        position: 'fixed',
        top,
        left,
        width: '150px',
        backgroundColor: 'lightsteelblue',
        zIndex: '1000000000'
      }}
    >
      <div
        onClick={e => {
          e.stopPropagation();
          addToTaxonomy(selectedText);
        }}
        className="context_menu__item"
      >
        <span>Add to Taxonomy</span>
      </div>
    </div>
  )
};


const mapStateToProps = state => ({
  top: state.contextMenu.top,
  left: state.contextMenu.left,
  isShown: state.contextMenu.isShown,
  selectedText: state.contextMenu.selectedText
});

const mapDispatchToProps = dispatch => ({
  addToTaxonomy: selectedText => {
    dispatch(textAreaWordsChange(selectedText));
    dispatch(showAddWordsModal());
    dispatch(hideContextMenu());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ContextMenu);


// WEBPACK FOOTER //
// ./src/modules/context-menu/context-menu-component.js